export default "__VITE_ASSET__B1j$FrFY__"